import queryString from 'query-string';
import { axios } from '~/clients';
import { USER_VEHICLE_AVAILABILITY } from '~/constants/endpoints';
import type { AvailabilityResponse } from '~/contracts/vdp';
import normalizeAvailabilityResponse from '~/utilities/vdp/normalizeAvailabilityResponse';

type OwnArgs = {
  userId?: string;
  vehicleId: number;
  zip: string;
};

export default async function fetchUserVehicleAvailability(
  { userId, vehicleId, zip: zipCode }: OwnArgs,
  controller?: AbortController
): Promise<AvailabilityResponse> {
  const qs = queryString.stringify({ userId, vehicleId, zipCode });

  const res = await axios.get<AvailabilityResponse>(
    `${USER_VEHICLE_AVAILABILITY}?${qs}`,
    {
      signal: controller?.signal
    }
  );

  return normalizeAvailabilityResponse(res.data, userId);
}
